import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Modal from "react-modal";
import Swal from "sweetalert2";
import axiosInstance from "../../config/axiosConfig";
import Actions from "../../components/courses/Actions";
import { CircularProgress } from "@mui/material";
import { MAX_SIZE_MB } from "../../helper";

// Styles for modal (you can customize as needed)
const customModalStyles = {
  content: {
    padding: "20px",
    width: "80%",
    maxWidth: "600px",
    margin: "auto",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  },
};

const Career = () => {
  const [careers, setCareers] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editCareerId, setEditCareerId] = useState(null);
  const [careersFetchLoading, setCareersFetchLoading] = useState(false);
  const [buttonLoading, setbuttonLoading] = useState(false);
  const [sortByLatest, setSortByLatest] = useState(false);
  const [jobFormFile, setjobFormFile] = useState(null);
  const [downloadAdFile, setdownloadAdFile] = useState(null);
  const [imgPreview, setImgPreview] = useState(null);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    type: "",
    startDate: "",
    endDate: "",
    jobForm: null,
    adId: null,
    downloadAd: "",
    scaleRange: ""
  });
  useEffect(() => {
    // Set image preview when formData.img changes (for edit case)
    if (formData.jobForm) {
      setImgPreview(formData.jobForm);
    }
  }, [formData.jobForm]);
  useEffect(() => {
    fetchCareers();
  }, []);

  const fetchCareers = async () => {
    setCareersFetchLoading(true);
    try {
      const response = await axiosInstance.get("career/all");
      setCareers(response.data.data);
    } catch (error) {
      console.error("Error fetching careers:", error);
    }
    setCareersFetchLoading(false);
  };

  // Handle create career
  const handleCreateCareer = async (e) => {
    e.preventDefault();
    setbuttonLoading(true);
    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
      if (key === "jobForm" || key === "downloadAd") {
        return;
      }
      if (formData[key] === null || formData[key] === undefined) {
        return;
      }
      formDataToSend.append(key, formData[key]);
    });
    if (jobFormFile) {
      formDataToSend.append("jobForm", jobFormFile);
    }
    if (downloadAdFile) {
      formDataToSend.append("downloadAd", downloadAdFile);
    }
    try {
      await axiosInstance.post("career/create", formDataToSend);
      fetchCareers();
      Swal.fire("Success!", "Career created successfully!", "success");
      setShowCreateModal(false);
      setFormData({
        title: "",
        description: "",
        type: "",
        startDate: "",
        endDate: "",
        jobForm: null,
        adId: null,
        downloadAd: "",
        scaleRange: ""
      });
      setjobFormFile(null);
      setdownloadAdFile(null);
      setImgPreview(null);
    } catch (error) {
      console.error("Error creating career:", error);
      const message = error.response?.data?.message || "Failed to create career";
      Swal.fire("Error", message, "error");
    }
    setbuttonLoading(false);
  };
  const handleViewCareer = async (id) => {
    try {
      setShowEditModal(true);
      setEditCareerId(id);
      const response = await axiosInstance.get(`career/single/${id}`);
      const data = response?.data?.data;
      setFormData({
        title: data.title || "",
        description: data.description || "",
        type: data.type || "",
        startDate: data.startDate || "",
        endDate: data.endDate || "",
        jobForm: data.jobForm || null,
        adId: data.adId || null,
        downloadAd: data.downloadAd || "",
        scaleRange: data.scaleRange || "",
      });
    } catch (error) {
      console.error("Error fetching Career:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error fetching Career!',
        text: 'Please try again.',
        timer: 1500,
      });
    }
  };

  // Handle edit career
  const handleEditCareer = async (e) => {
    e.preventDefault();
    setbuttonLoading(true);
    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
      if (key === "jobForm" || key === "downloadAd") {
        return;
      }
      if (formData[key] === null || formData[key] === undefined) {
        return;
      }
      formDataToSend.append(key, formData[key]);
    });
    if (jobFormFile) {
      formDataToSend.append("jobForm", jobFormFile);
    }
    if (downloadAdFile) {
      formDataToSend.append("downloadAd", downloadAdFile);
    }
    formDataToSend.append("_method", "PUT");
    try {
      await axiosInstance.post(`career/change/${editCareerId}`, formDataToSend);
      fetchCareers();
      setShowEditModal(false);
      setjobFormFile(null);
      setdownloadAdFile(null);
      Swal.fire("Success!", "Career updated successfully!", "success");
    } catch (error) {
      console.error("Error updating career:", error);
      const message = error.response?.data?.message || "Failed to update career";
      Swal.fire("Error", message, "error");
    }
    setbuttonLoading(false);
  };

  // Handle delete career
  const handleDeleteCareer = async (id) => {
    try {

      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!',
      });

      if (result.isConfirmed) {
        await axiosInstance.delete(`career/delete/${id}`);
        fetchCareers();
        Swal.fire("Deleted!", "Career deleted successfully", "success");
        fetchCareers();
      }

    } catch (error) {
      console.error("Error deleting career:", error);
      Swal.fire("Error", "Failed to delete career", "error");
    }
  };
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  const sortedCareers = sortByLatest
    ? [...careers].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    : careers || [];
  const handleFileChange = (e) => {
    const { name, files } = e.target;
    const file = files[0];

    if (file) {
      const fileSizeInMB = file.size / (1024 * 1024);
      if (fileSizeInMB > MAX_SIZE_MB) {
        alert(
          `File size exceeds ${MAX_SIZE_MB} MB. Please upload a smaller file.`
        );
        e.target.value = "";
        return;
      }

      if (name === "jobForm") {
        setjobFormFile(file);
        setImgPreview(URL.createObjectURL(file));
      } else if (name === "downloadAd") {
        setdownloadAdFile(file);

      }
    }
  };
  return (
    <div>
      {/* Top Navigation Tabs */}
      <div style={{ display: "flex", gap: "12px", borderBottom: "2px solid #e2e8f0", marginBottom: "24px" }}>
        <Link
          to="/career"
          style={{
            padding: "10px 20px",
            textDecoration: "none",
            color: "#2563eb",
            fontWeight: 700,
            fontSize: "15px",
            borderBottom: "3px solid #2563eb",
            backgroundColor: "#eff6ff",
            borderRadius: "6px 6px 0 0",
          }}
        >
          💼 Job Openings
        </Link>
        <Link
          to="/career/applicants"
          style={{
            padding: "10px 20px",
            textDecoration: "none",
            color: "#64748b",
            fontWeight: 600,
            fontSize: "15px",
            borderBottom: "3px solid transparent",
            transition: "all 0.2s",
          }}
        >
          📋 List of Applicants
        </Link>
      </div>

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <button
          onClick={() => setShowCreateModal(true)}
          style={{
            padding: "10px 20px",
            backgroundColor: "#4CAF50",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            marginBottom: "20px",
            cursor: "pointer",
          }}
        >
          Create New Career
        </button>
        <button
          onClick={() => setSortByLatest((prev) => !prev)}
          style={{
            padding: "10px 20px",
            backgroundColor: sortByLatest ? "#2196F3" : "#f0f0f0",
            color: sortByLatest ? "#fff" : "#000",
            border: "none",
            borderRadius: "5px",
            marginBottom: "20px",
            cursor: "pointer",
            marginRight: "150px",
          }}
        >
          {sortByLatest ? "Show Default" : "Show Latest"}
        </button>
      </div>

      <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
        {careersFetchLoading ? <div style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 9999,
        }}> <CircularProgress /> </div> :
          sortedCareers.map((career) => (
            <div
              key={career._id}
              style={{
                width: "250px",
                padding: "15px",
                borderRadius: "8px",
                backgroundColor: "#fff",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                textAlign: "center",
              }}
            >
              <h3>{career.title}</h3>
              <p>{career.description}</p>
              <p>{career.scaleRange}</p>
              <Actions
                courseId={career._id}
                onEdit={handleViewCareer}
                onDelete={handleDeleteCareer}
              />
            </div>
          ))}
      </div>

      {/* Create Career Modal */}
      <Modal
        isOpen={showCreateModal}
        onRequestClose={() => setShowCreateModal(false)}
        style={customModalStyles}
        contentLabel="Create New Career"
      >
        <h2>Create New Career</h2>
        <form onSubmit={handleCreateCareer}>
          {[
            { label: "Title", name: "title", type: "text" },
            { label: "Description", name: "description", type: "textarea" },
            { label: "Scale Range", name: "scaleRange", type: "text" },
            { label: "Type", name: "type", type: "dropdown", required: true, options: ["Full-time", "Part-time", "Contract/Tenured", "Visiting"] },
            { label: "Start Date", name: "startDate", type: "date" },
            { label: "End Date", name: "endDate", type: "date" },
            { label: "Ad ID", name: "adId", type: "text" },
          ].map(({ label, name, type, required, options }) => (
            <div key={name} style={{ marginBottom: "10px" }}>
              <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>
                {label}
              </label>
              {type === "dropdown" ? (
                <select
                  name={name}
                  value={formData[name]}
                  onChange={handleChange}
                  required={required}
                  style={{
                    width: "100%",
                    padding: "8px",
                    fontSize: "14px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                >
                  <option value="">Select an option</option>
                  {options.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              ) : type === "textarea" ? (
                <textarea
                  name={name}
                  value={formData[name]}
                  onChange={handleChange}
                  required={required}
                  style={{
                    width: "100%",
                    padding: "8px",
                    fontSize: "14px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                    height: "100px",
                  }}
                />

              ) : (
                <input
                  type={type}
                  name={name}
                  value={formData[name]}
                  onChange={handleChange}
                  required={required}
                  style={{
                    width: "100%",
                    padding: "8px",
                    fontSize: "14px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                />
              )}
            </div>

          ))}
          <div style={{ marginBottom: "10px" }}>
            <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>
              Upload Job form
            </label>
            <input
              type="file"
              // accept="image/*"
              onChange={handleFileChange}
              name="jobForm"
              style={{
                width: "100%",
                padding: "8px",
                fontSize: "14px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
            />
            {imgPreview && (
              <img
                src={imgPreview}
                alt="Preview"
                style={{ width: "30%", height: "auto", marginBottom: "15px" }}
              />
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>
              Upload downlaod Ad
            </label>
            <input
              type="file"
              // accept="pdf/*"
              onChange={handleFileChange}
              name="downloadAd"
              style={{
                width: "100%",
                padding: "8px",
                fontSize: "14px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
            />
          </div>
          <button
            type="submit"
            style={{
              padding: "10px 20px",
              backgroundColor: "#4CAF50",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              marginTop: "10px",
            }}
          >
            {buttonLoading ? <CircularProgress size={24} color="inherit" /> : "Create"}
          </button>
        </form>
      </Modal>

      <Modal
        isOpen={showEditModal}
        onRequestClose={() => {
          setShowEditModal(false);
          setFormData({
            title: "",
            description: "",
            type: "",
            startDate: "",
            endDate: "",
            jobForm: null,
            adId: null,
            downloadAd: "",
            scaleRange: ""
          })
          setImgPreview(null);
        }}
        style={customModalStyles}
        contentLabel="Update Career"
      >
        <h2>Update Career</h2>
        <form onSubmit={handleEditCareer}>
          {[
            { label: "Title", name: "title", type: "text" },
            { label: "Description", name: "description", type: "textarea" },
            { label: "Scale Range", name: "scaleRange", type: "text" },
            { label: "Type", name: "type", type: "dropdown", required: true, options: ["Full-time", "Part-time", "Contract/Tenured", "Visiting"] },
            { label: "Start Date", name: "startDate", type: "date" },
            { label: "End Date", name: "endDate", type: "date" },
            { label: "Ad ID", name: "adId", type: "text" },
          ].map(({ label, name, type, required, options }) => (
            <div key={name} style={{ marginBottom: "10px" }}>
              <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>
                {label}
              </label>
              {type === "dropdown" ? (
                <select
                  name={name}
                  value={formData[name]}
                  onChange={handleChange}
                  required={required}
                  style={{
                    width: "100%",
                    padding: "8px",
                    fontSize: "14px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                >
                  <option value="">Select an option</option>
                  {options.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              ) : type === "textarea" ? (
                <textarea
                  name={name}
                  value={formData[name]}
                  onChange={handleChange}
                  required={required}
                  style={{
                    width: "100%",
                    padding: "8px",
                    fontSize: "14px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                    height: "100px", // Adjust height as needed
                  }}
                />

              ) : (
                <input
                  type={type}
                  name={name}
                  value={formData[name]}
                  onChange={handleChange}
                  required={required}
                  style={{
                    width: "100%",
                    padding: "8px",
                    fontSize: "14px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                />
              )}
            </div>
          ))}
          <div style={{ marginBottom: "10px" }}>
            <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>
              Upload Job form
            </label>
            <input
              type="file"
              // accept="image/*"
              onChange={handleFileChange}
              name="jobForm"
              style={{
                width: "100%",
                padding: "8px",
                fontSize: "14px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
            />
            {imgPreview && (
              <img
                src={imgPreview}
                alt="Preview"
                style={{ width: "30%", height: "auto", marginBottom: "15px" }}
              />
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>
              Upload downlaod Ad
            </label>
            <input
              type="file"
              // accept="pdf/*"
              onChange={handleFileChange}
              name="downloadAd"
              style={{
                width: "100%",
                padding: "8px",
                fontSize: "14px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
            />
          </div>
          <button
            type="submit"
            style={{
              padding: "10px 20px",
              backgroundColor: "#4CAF50",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              marginTop: "10px",
            }}
          >
            {buttonLoading ? <CircularProgress size={24} color="inherit" /> : "Update"}
          </button>
        </form>
      </Modal>
    </div>
  );
};

export default Career;
